/* tslint:disable */
/* eslint-disable */
/**
 * Bank Accounts API
 * API for managing bank accounts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopyBankAccountCommand
 */
export interface CopyBankAccountCommand {
    /**
     * Personne cible (co-emprunteur)
     * @type {string}
     * @memberof CopyBankAccountCommand
     */
    targetPersonId: string;
}

/**
 * Check if a given object implements the CopyBankAccountCommand interface.
 */
export function instanceOfCopyBankAccountCommand(value: object): value is CopyBankAccountCommand {
    if (!('targetPersonId' in value) || value['targetPersonId'] === undefined) return false;
    return true;
}

export function CopyBankAccountCommandFromJSON(json: any): CopyBankAccountCommand {
    return CopyBankAccountCommandFromJSONTyped(json, false);
}

export function CopyBankAccountCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopyBankAccountCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'targetPersonId': json['targetPersonId'],
    };
}

export function CopyBankAccountCommandToJSON(json: any): CopyBankAccountCommand {
    return CopyBankAccountCommandToJSONTyped(json, false);
}

export function CopyBankAccountCommandToJSONTyped(value?: CopyBankAccountCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetPersonId': value['targetPersonId'],
    };
}

